import { render } from "./OptionInfo.vue?vue&type=template&id=5fd27f0e&scoped=true"
import script from "./OptionInfo.vue?vue&type=script&lang=js"
export * from "./OptionInfo.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=5fd27f0e&scoped=true&lang=css"
import "@/assets/css/user/pages/menu.css?vue&type=style&index=1&id=5fd27f0e&scoped=true&lang=css"
import "@/assets/css/user/pages/lst-allergy.css?vue&type=style&index=2&id=5fd27f0e&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=5fd27f0e&scoped=true&lang=css"
import "@/assets/css/user/dark/menu-dark.css?vue&type=style&index=4&id=5fd27f0e&scoped=true&lang=css"
import "@/assets/css/user/dark/lst-allergy-dark.css?vue&type=style&index=5&id=5fd27f0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd27f0e"]])

export default __exports__